// ─────────────────────────────────────────────────────────
// services/dexieClient.ts — Dexie database definition
//
// Replaces the raw IndexedDB API previously in idb.ts and
// the cbd_offline write-queue DB previously in offline.ts.
//
// Database : cbd_data
// Version  : 1 — 28 data object stores (same as before)
// Version  : 2 — adds write_queue table (merged from cbd_offline)
//
// All data tables use 'id' as keyPath, matching the existing
// IDB schema so Dexie opens the database in-place without
// losing any existing stored data.
// ─────────────────────────────────────────────────────────
import Dexie, { type Table } from 'dexie'
import type { QueuedWrite } from './offline'

class CivilBillDeskDB extends Dexie {
  // ── Data tables (one per collection, all keyed by 'id') ──
  proj!:        Table<any>
  boq!:         Table<any>
  milestones!:  Table<any>
  daily!:       Table<any>
  tender!:      Table<any>
  emd!:         Table<any>
  recv!:        Table<any>
  ret!:         Table<any>
  exp!:         Table<any>
  cf!:          Table<any>
  petty!:       Table<any>
  recon!:       Table<any>
  vendor!:      Table<any>
  po!:          Table<any>
  quotations!:  Table<any>
  invoice!:     Table<any>
  emp!:         Table<any>
  adv!:         Table<any>
  ins!:         Table<any>
  tds!:         Table<any>
  einvoices!:   Table<any>
  task!:        Table<any>
  audit!:       Table<any>
  notif!:       Table<any>
  attendance!:  Table<any>
  salaries!:    Table<any>
  brand!:       Table<any>
  meta!:        Table<any>

  // ── Write-queue table (merged from cbd_offline) ──────────
  write_queue!: Table<QueuedWrite>

  constructor() {
    super('cbd_data')

    // Version 1 — all 28 data stores (inherits existing IDB schema)
    this.version(1).stores({
      proj:       'id',
      boq:        'id',
      milestones: 'id',
      daily:      'id',
      tender:     'id',
      emd:        'id',
      recv:       'id',
      ret:        'id',
      exp:        'id',
      cf:         'id',
      petty:      'id',
      recon:      'id',
      vendor:     'id',
      po:         'id',
      quotations: 'id',
      invoice:    'id',
      emp:        'id',
      adv:        'id',
      ins:        'id',
      tds:        'id',
      einvoices:  'id',
      task:       'id',
      audit:      'id',
      notif:      'id',
      attendance: 'id',
      salaries:   'id',
      brand:      'id',
      meta:       'id',
    })

    // Version 2 — add write_queue (merges the old cbd_offline DB)
    this.version(2).stores({
      write_queue: '++id, col, queuedAt',
    })
  }
}

export const dexieDb = new CivilBillDeskDB()
